import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/events/halloween/event-entry/icon-close.webp")